import React, { useState } from "react";
import cn from "classnames";
import styles from "./Details.module.sass";
import Icon from "../../../Icon";
import Overview from "./Overview";
import Products from "./Products";
import Comments from "./Comments";


const Details = ({ className, setValue, activeIndex, setActiveIndex }) => {
  const handleClick = (index) => {
    setActiveIndex(index);
    index === 0 && setValue(false);
    index === 1 && setValue(true);
  };

  return (
    <div className={cn(styles.details, className)}>
      <div className={styles.head}>
        <div className={styles.btns}>
          <button className={cn("button-stroke", styles.favorite)}>
            <Icon name="heart-fill" size="24" />
            <span>32</span>
          </button>
          <button className={cn("button", styles.follow)}>
            <span className={styles.inner}>Obserwuj</span>
          </button>
          <button className={cn("button", styles.subscribe)}>
            <span className={styles.inner}>
              Subskrybuj
            </span>
          </button>
        </div>
      </div>
      <Overview />
      <Comments />
      <Products />
    </div>
  );
};

export default Details;
